import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import startsImage from './images/stars.svg'

const RootContainer = styled.div`
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	left: 50%;
	width: 100vw;
	top: 0;
	margin: 0 auto;
	min-width: ${props => props.width};
	transform: translateX(-50%);
	user-select: no-select;
	
	img {
		${props => `
			width: ${props.width};
			height: ${props.height};
			transform: rotate(${props.rotate});
		`}
	}
`

const StarsContainer = ({className, width, height, rotate}) => <RootContainer
	width={width}
	height={height}
	rotate={rotate}
	className={className}>
	<img src={startsImage} alt=''/>
</RootContainer>

StarsContainer.propTypes = {
	className: PropTypes.string,
	width: PropTypes.string,
	height: PropTypes.string,
	rotate: PropTypes.string,
}

StarsContainer.defaultProps = {
	className: '',
	width: '66rem',
	height: 'auto',
	rotate: '0deg',
}

export default StarsContainer
